/**
 * Created by ljybill@aliyun.com  on 2018/7/2
 */
import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js